export default "__VITE_ASSET__27476d13__"